<template>
	<div class="Release">
		<el-form
				:model="selectForm"
				ref="selectForm"
				:label-position="labelPosition"
				label-width="120"
				inline
				class="custom-formScreen"
		>
			<el-form-item
					label="选择分公司"
					prop="branchCompany"
					v-if="
							[1].includes(str.type) &&
								str.superDepartmentName !== '客服部' &&
								str.superDepartmentName !== '常规客服部'
						"
			>
				<el-select
						v-model="value6"
						placeholder="请选择"
						@change="shopChange6"
						value-key="company_id"
						filterable
				>
					<el-option
							v-for="item in arr6"
							:key="item.company_id"
							:label="item.companyName"
							:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item
					label="选择子公司"
					prop="sonCompany"
					v-if="[2, 1].includes(str.type)"
			>
				<el-select
						v-model="value7"
						placeholder="请选择"
						value-key="rid"
						@change="shopChange7"
						filterable
				>
					<el-option
							v-for="item in arr7"
							:key="item.company_id"
							:label="item.companyName"
							:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择分部门" v-if="!disabledInput2">
				<el-select
						v-model="value2"
						filterable
						placeholder="请选择"
						@change="shopChange2"
				>
					<el-option
							v-for="item2 in this.arr1"
							:key="item2.value"
							:label="item2.departmentName"
							:value="item2"
					></el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="选择组" v-if="!disabledInput3">
				<el-select
						v-model="value3"
						filterable
						placeholder="请选择"
						@change="shopChange3"
				>
					<el-option
							v-for="item3 in this.arr2"
							:key="item3.value"
							:label="item3.groupName"
							:value="item3"
					></el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="选择员工" v-if="!disabledInput4">
				<el-select
						v-model="value4"
						filterable
						placeholder="请选择"
						@change="shopChange4"
				>
					<el-option
							v-for="item4 in this.arr3"
							:key="item4.value"
							:label="item4.roleUserName"
							:value="item4"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择店铺" prop="shopvalue">
				<el-select
						v-model="value5"
						filterable
						placeholder="请选择"
						clearable
						@change="shopChange5"
				>
					<el-option
							v-for="item5 in this.arr4"
							:key="item5.value"
							:label="item5.shopName"
							:value="item5"
							:style="{ color: item5.state === 0 ? 'red' : '' }"
					></el-option>
				</el-select>
			</el-form-item>
			<!--					<el-form-item label="采购需求状态" prop="purchaseDemandValue">-->
			<!--						<el-select-->
			<!--								v-model="selectForm.demandValue"-->
			<!--								placeholder="请选择"-->
			<!--								@change="changeDemand"-->
			<!--								@clear="changeDemand"-->
			<!--								clearable-->
			<!--						>-->
			<!--							<el-option-->
			<!--									v-for="(item, index) in demandValue"-->
			<!--									:key="index"-->
			<!--									:label="item.label"-->
			<!--									:value="item.label"-->
			<!--							></el-option>-->
			<!--						</el-select>-->
			<!--					</el-form-item>-->
			<el-form-item label="开始日期" prop="startTime">
				<el-date-picker
						v-model="selectForm.startTime"
						align="right"
						type="datetime"
						placeholder="选择日期"
						format="yyyy-MM-dd HH:mm:ss"
						@change="startTime"
						:picker-options="pickerOptions"
				></el-date-picker>
				<!-- @change="startTime" -->
			</el-form-item>
			<el-form-item label="结束日期" prop="endTime">
				<el-date-picker
						v-model="selectForm.endTime"
						align="right"
						type="datetime"
						placeholder="选择日期"
						format="yyyy-MM-dd HH:mm:ss"
						@change="endTime"
						:picker-options="pickerOptions"
				></el-date-picker>

			</el-form-item>

			<el-input clearable placeholder="请输入查询内容" v-model="selectForm.searchStr" style="width: 360px;margin-top: 3px" @input="selectForm.searchStr = selectForm.searchStr.replace(/\s+/g, '')"
					>
				<el-select v-model="selectForm.searchType" slot="prepend" style="width: 100px" clearable
						  >
					<el-option label="ParentSKU" value="1"></el-option>
					<el-option label="SKU" value="2"></el-option>
					<el-option label="产品编号" value="3"></el-option>
					<el-option label="标题" value="4"></el-option>
					<el-option label="备注" value="5"></el-option>
				</el-select>
			</el-input>




			<el-button
				type="primary"
				style="margin-left: 10px;"
				@click="Search2"
		>搜索</el-button
		>
			<el-button type="primary" @click="searchReset"
			>重置</el-button>
		</el-form>
		<div class="summary_bag">
			<div class="summary_complete_bag">
				<div class="status_button">
					<el-radio-group v-model="selectForm.releaseStatus" style="margin-bottom: 30px;" @change="changeStatus">
						<el-radio-button label="88">全部</el-radio-button>
						<el-radio-button label="0">待完善</el-radio-button>
						<el-radio-button label="1">待发布</el-radio-button>
						<el-radio-button label="2">审核中</el-radio-button>
						<el-radio-button label="4">成功</el-radio-button>
						<el-radio-button label="3">失败</el-radio-button>
					</el-radio-group>
				</div>
			</div>
			<!-- 符合查询条件的产品共-->
			<div class="summary_pagenum">
				<div class="summary_query">
					符合查询条件的产品共
					<span>{{ count }}</span>
					件
				</div>
			</div>
			<div class="summary_content">
				<div class="summary_batch">
					<span>已选择产品{{ piece }}件</span>
					<template>
						<span @click="addNewProduct(false)" style="cursor:pointer" v-if="system == 5">创建</span>
						<span @click="copyProduc(false)" style="cursor:pointer"  v-if="system == 5">复制</span>
						<span @click="deleteProduct(false)" style="cursor:pointer"  v-if="system == 5">删除</span>
						<span @click="displayProduc(false)" style="cursor:pointer"  v-if="system == 5">发布</span>
						<span @click="tbProduc(false)" style="cursor:pointer"  v-if="system == 5">同步</span>
					</template>
				</div>
				<div class="summary_list">
					<!-- 头部 -->
					<el-table
							:data="tableList"
							style="width: 100%"
							v-loading="load_data"
							element-loading-text="拼命加载中"
							border
							@selection-change="on_batch_select"
							:header-cell-style="iscenter"
							stripe
							class="pg-table"
							:cell-class-name="'pg-cell'"
							:header-cell-class-name="'pg-header-cell'"
							fit

					>
						<!-- :cell-style="style" -->
						<el-table-column
								width="50"
								type="selection"
								align="center"
						></el-table-column>
						<el-table-column
								label="图片"
								width="120"
								align="left"
						>
							<template slot-scope="scope">
								<el-popover trigger="hover" placement="right" v-if="scope.row.images && scope.row.images.length > 0" :open-delay="600">
									<img
											:src="scope.row.images[0]"
											class="prduct_img"
											alt
									/>
									<div class="scope_img" slot="reference">
										<img
												:src="scope.row.images[0]"
												alt
										/>
									</div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column
								width="320"
								label="标题/编号/父SKU/店铺/分类/完成度"
								prop="productNumber"
								align="left"
						>
							<template slot-scope="scope">
								<div>
									<el-link
										:href="'https://www.ozon.ru/product/ProductID/'+ scope.row.productId"
										target="_blank"
										type="primary"
								>{{scope.row.name}}</el-link>
								</div>
								<div>{{scope.row.productNumber}}</div>
								<div>{{scope.row.sku}}</div>
								<div>{{scope.row.shopName}}</div>
								<div>{{scope.row.typeName+'('+ scope.row.typeNameCn + ')'}}</div>
								<div>{{scope.row.completeness}}</div>
							</template>
						</el-table-column>
						<el-table-column
								width="80"
								prop="productType"
								label="状态"
								align="center"
						>
							<template slot-scope="scope">
								<el-tag v-if="scope.row.releaseStatus == 0" type="info">待完善</el-tag>
								<el-tag v-if="scope.row.releaseStatus == 1" type="warning">待发布</el-tag>
								<el-tag v-if="scope.row.releaseStatus == 2">审核中</el-tag>
								<el-tag v-if="scope.row.releaseStatus == 3" type="danger">失败</el-tag>
								<el-tag v-if="scope.row.releaseStatus == 4" type="success">成功</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="角色/时间/审核提示"
										 align="left">
							<template slot-scope="scope">
								<div v-if="scope.row.roleName">{{scope.row.roleName}}</div>
								<div v-if="scope.row.updateTime">{{scope.row.updateTime}}</div>
								<div v-if="scope.row.uploadResultList && scope.row.uploadResultList.length > 0">
									<el-link type="primary" @click="clickBugTip(scope.row.uploadResultList)">{{ scope.row.uploadResultList }}</el-link></div>
							</template>
						</el-table-column>

						<el-table-column
								label="操作"
								:width="100"
								align="center"
						>
							<template slot-scope="scope">
								<template>
										<div>
											<!--待完善、待发布、失败显示-->
											<el-button
													type="primary"
													icon="el-icon-edit"
													v-if="(scope.row.releaseStatus == '0' || scope.row.releaseStatus == '1' || scope.row.releaseStatus == '3') && system == 5"
													@click="clickEdit(scope.row)"
											>编辑</el-button>
										</div>
										<div>

											<!--待发布：显示 -->
											<el-button
													type="primary"
													icon="el-icon-position"
													v-if="scope.row.releaseStatus == '1' && system == 5"
													@click="displayProduc(scope.row)"
											>发布</el-button>
										</div>
										<div>
											<!--审核中显示-->
											<el-button
													type="primary"
													icon="el-icon-thumb"
													v-if="scope.row.releaseStatus == '2' && system == 5"
													@click="tbProduc(scope.row)"
											>同步</el-button>
										</div>
										<div>
											<el-button
													type="primary"
													v-if="system == 5"
													icon="el-icon-copy-document"
													@click="copyProduc(scope.row)"
													style="background: rgb(112,182,3)"
											>复制</el-button>
										</div>
										<div>
											<!--审核中不显示-->
											<el-button
													type="danger"
													icon="el-icon-delete"
													v-if="scope.row.releaseStatus != '2' && system == 5"
													@click="deleteProduct(scope.row)"
											>删除</el-button>
										</div>
									<div>
										<!--审核中不显示-->
										<el-button
												type="primary"
												icon="el-icon-view"
												v-if="system < 5 || scope.row.releaseStatus == 4"
												@click="clickEdit(scope.row,'chakan')"
										>查看</el-button>
									</div>
								</template>
							</template>
						</el-table-column>
						<el-table-column label="SKU" min-width="160" :show-overflow-tooltip="false"
										 align="left">
							<template slot-scope="scope">
								<div style="display: flex;flex-direction: column">
									<div v-for="(item,index) in scope.row.variantBasicVos" :key="index + 'SKU1'" class="item_sku" v-if="index < 3 && !scope.row.isShowAll" style="display: flex;align-items: center">
										<div :class="returnClass(item)" @click="clickSKUResult(item)"></div> <span style="margin-left: 10px">{{item.offerId}}</span>
									</div>
									<div v-for="(item,index) in scope.row.variantBasicVos" :key="index + 'SKU2'" class="item_sku" v-if="scope.row.isShowAll" style="display: flex;align-items: center">
										<div :class="returnClass(item)" @click="clickSKUResult(item)"></div> <span style="margin-left: 10px">{{item.offerId}}</span>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="stock" label="库存" width="100"
										 align="left">
							<template slot-scope="scope">
								<div style="display: flex;flex-direction: column">
									<div v-for="(item,index) in scope.row.variantBasicVos" :key="index + 'stock1'" class="item_sku" v-if="index < 3 && !scope.row.isShowAll">
										{{item.stock}}
									</div>
									<div v-for="(item,index) in scope.row.variantBasicVos" :key="index + 'stock2'" class="item_sku" v-if="scope.row.isShowAll">
										{{item.stock}}
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="title" label="价格" width="140"
										 align="left">
							<template slot-scope="scope">
								<div style="display: flex;width: 100%;justify-content: space-between">
									<div style="display: flex;flex-direction: column">
										<div v-for="(item,index) in scope.row.variantBasicVos" :key="index + 'price1'" class="item_sku" v-if="index < 3 && !scope.row.isShowAll">
										<span>{{item.price ? item.price + scope.row.currencyCode:'0' + scope.row.currencyCode}}</span>
										</div>
										<div v-for="(item,index) in scope.row.variantBasicVos" :key="index + 'price2'" class="item_sku" v-if="scope.row.isShowAll">
											<span>{{item.price ? item.price + scope.row.currencyCode:'0' + scope.row.currencyCode}}</span>
										</div>
									</div>
									<div style="display: flex;align-items: center" v-if="scope.row.variantBasicVos && scope.row.variantBasicVos.length > 3">
										<div class="zhankai_shouqi" @click="clickZhankai(scope.row)">
											<i class="iconfont icon-zhankai"  style="color:#fff;" v-if="!scope.row.isShowAll"></i>
											<i class="iconfont icon-shouqi"  style="color:#fff;" v-if="scope.row.isShowAll"></i>
										</div>
									</div>
								</div>

							</template>
						</el-table-column>

					</el-table>
					<div class="summary_pagenum_block">
					<div class="block">
						<el-pagination
								@current-change="handleCurrentChange"
								:current-page="currentPage"
								@size-change="handleSizeChange"
								:page-sizes="[10, 20, 50, 100]"
								layout="total, sizes, prev, pager, next, jumper"
								:total="count"
						></el-pagination>
					</div>
				</div>

				</div>
			</div>
		</div>

		<el-dialog
				:title="title"
				:visible.sync="dialogVisible"
				width="90%"
				top="5vh"
		>
			<div class="select-row" slot="title">
				<div class="label">{{ title }}</div>
				<el-button type="primary" @click="citationDatabase">引用数据库</el-button>
			</div>
			<div v-loading="dialogLoding" ref="dia_box">
				<baseInfo @addToBianti="addToBianti" @setBiantiList="setBiantiList" @setBiantiList2="setBiantiList2"
						  @editDescJson="editDescJson"  @editShipinDesc="editShipinDesc" @editCangku="editCangku"
						  @changeSku="changeSku"  @changeName="changeName"  @resetBianti="resetBianti" ref="baseInfo" @changeCurrencyCode="changeCurrencyCode"></baseInfo>
				<description ref="description"/>
				<laiyuan ref="laiyuan"/>
				<shipin ref="shipin"/>
				<wuliu ref="wuliu"/>
				<uploadPictures
						@ImgList="ImgList"
						ref="uploadPictures"
						:page-type="pageType"
						@downloadImgs="downloadImgs"
				/>
				<bianti ref="bianti"  @changeReamrk="changeReamrk" @changeTopAttr="changeTopAttr"
						:img-select-list="productImgArr" @addImageList="addImageList"/>
			</div>

			<span slot="footer" style="margin-top: 60px">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="saveChanpin(false)" v-if="system == 5 && !isChakan" :loading="saveLoadding">保 存</el-button>
					<el-button type="primary" @click="saveAndfabu" style="margin-right: 30px" v-if="system == 5 && !isChakan" :loading="saveLoadding">保存并发布</el-button>
  			</span>
		</el-dialog>
		<el-dialog
				title="审核提示"
				:visible.sync="dialogVisibleShenhe"
				width="80%"
				top="5vh"
		>
			<div v-for="(item,index) in bugContentList" :key="index">
				{{item}}
			</div>
			<span slot="footer" style="margin-top: 60px">
					<el-button @click="dialogVisibleShenhe = false">取 消</el-button>
  			</span>
		</el-dialog>
		<el-dialog
				title="复制产品"
				:visible.sync="dialogVisibleFuzhi"
				width="500px"
				top="5vh"
		>
			<el-form
					:model="dianpuForm"
					:label-position="labelPosition"
					label-width="160"
			>
				<el-form-item label="选择店铺">
					<el-select
							v-model="fuzhiDianpuObj"
							placeholder="请选择店铺"
							@change="changeDianpuId"
							style="margin-left: 20px;width: 300px"
					>
						<el-option
								v-for="item5 in this.arr4"
								:key="item5.value"
								:label="item5.shopName"
								:value="item5"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择仓库" v-if="fuzhiDianpuObj && fuzhiDianpuObj.sellerId">
					<el-select
							v-model="warehouseId"
							placeholder="请选择仓库"
							style="margin-left: 20px;width: 300px"
					>
						<el-option
								v-for="item in this.warehouseIdList"
								:key="item.warehouse_id"
								:label="item.name"
								:value="item.warehouse_id"
						></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" style="margin-top: 60px">
					<el-button @click="dialogVisibleFuzhi = false">取 消</el-button>
					<el-button type="primary" @click="clickFuzhi">确 认</el-button>
  			</span>
		</el-dialog>
		<el-dialog title="上传结果" :visible.sync="dialogResultVisible">
				<div v-for="(value,key) in resultContent" :key="key" style="display:flex;margin-bottom:5px">

					<div class="item_err">{{key}}:</div>
					<div class="item_err_content">
						<span v-if="key != 'errors'">{{value}}</span>
						<div v-if="key == 'errors'" >
							<div class="error_item" v-for="(item,index) in value" :key="index">
								{{item}}
<!--							<div class="item_err_title"></div>-->
<!--							<div class="item_err_content"></div>-->
							</div>
						</div>
					</div>
				</div>
		</el-dialog>
		<el-dialog title="引用数据库" :visible.sync="dialogDBVisible" top="6vh" width="1600px">
			<div class="select-row">
				<div class="select-item">
					<div class="label">产品关键字</div>
					<el-input v-model="searchTerm" placeholder="请输入产品关键字" filterable>
					</el-input>
				</div>
				<div class="select-item">
					<div class="label">店铺链接</div>
					<el-input v-model="shopLink" placeholder="请输入店铺链接" filterable>
					</el-input>
				</div>
				<div class="select-item">
					<div class="label">sku</div>
					<el-input v-model="sku" placeholder="请输入sku，多个sku使用英文逗号隔开" filterable>
					</el-input>
				</div>
				<el-button type="primary" @click="searchNetworkData">查询</el-button>
				<el-button type="primary" @click="openAiView">打开ai辅助页面</el-button>
			</div>
			<div class="network-content">
				<div class="network-item" :class="item.state ? 'active' : ''" v-for="item in netWorkData" :key="item.sku" @click="changeState(item)">
					<img :src="item.ozonImageList && item.ozonImageList.length > 0 ? item.ozonImageList[0] : ''" alt="" srcset="">
					<div class="title">{{ item.title }}</div>
					<div class="score">{{ item.score }}</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>

	let isUpdate = false
	import { Loading } from 'element-ui'
	import { ajaxPost, Baseurl,ajaxGet } from '@/api/api/api'
	import baseInfo from './components/baseInfo.vue'
	import description from "./components/description";
	import laiyuan from "./components/laiyuan";
	import shipin from "./components/shipin";
	import wuliu from "./components/wuliu";
	import uploadPictures from "./components/uploadPictures";
	import bianti from "./components/bianti";

	export default {
		name: 'productDisplay',
		components: {
			baseInfo,
			description,
			laiyuan,
			shipin,
			wuliu,
			uploadPictures,
			bianti,
		},
		// beforeRouteEnter(to, from, next) {
		// 	//待定，貌似刷新用的
		// 	// if (from.name == 'editProduct') {
		// 	// 	isUpdate = true
		// 	// } else {
		// 	// 	isUpdate = false
		// 	// }
		// 	// next()
		// },
		data() {
			return {
				isChakan:false,
				saveLoadding:false,
				title:'添加产品',
				dialogResultVisible:false,
				resultContent:{},
				//是否为编辑
				isEdit:false,
				bianjiProductId:'',
				loading:null,
				dialogLoding:false,
				batch_select:[],
				productImgArr: [],
				fuzhiId:'',
				searchTerm: '',
				shopLink: '',
				sku: '',
				//复制店铺的
				fuzhiDianpuObj:{},
				//仓库id
				warehouseId:'',
				//仓库列表
				warehouseIdList:[],
				//选择店铺获得的sellerid
				sellerId:'',
				//选择店铺获得的ShopId
				markShopId:'',
				show:'',
				state:'',
				strSeller:'',
				//标识 1boss 2 部长 3分部长 4 组长 5普通员工
				system:'5',
				//角色id
				rid:'',
				companyInfo: {},
				labelPosition: 'right',

				str: '',
				value2: '',
				//组
				value3: '',
				//员工
				value4: '',
				//店铺
				value5: '',
				//分公司
				value6: '',
				//子公司
				value7: '',
				arr: [],
				arr1: [],
				arr2: [],
				arr3: [],
				arr4: [],
				arr5: [],
				arr6: [],
				arr7: [],
				//平台名称
				sellerType: 8,
				disabledInput: '',
				disabledInput2: '',
				disabledInput3: '',
				disabledInput4: '',
				dianpuForm:{},
				selectForm: {
					page: 1,
					size: 20,
					//查询类型
					searchType:'1',
					//查询内容
					searchStr:'',
					startTime: '', //开始时间
					endTime: '', //结束时间
					timeType:1,
					//角色id
					staffId: "",
					//店铺id
					sellerId: "",
					//公司id
					companyId:'',
					releaseStatus: 88,
					isTranslation: 1
				},
				pickerOptions: {
					shortcuts: [{
						text: '本月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date);
							this.calculationDate()
						}
					}, {
						text: '上一月',
						onClick: (picker) => {
							const date = new Date();
							picker.$emit('pick', date);
							this.calculationDate(-1)
						}
					}, {
						text: '上两月',
						onClick: (picker) => {
							const date = new Date();
							picker.$emit('pick', date);
							this.calculationDate(-2)
						}
					}, {
						text: '上三月',
						onClick: (picker) => {
							const date = new Date();
							picker.$emit('pick', date);
							this.calculationDate(-3)
						}
					}]
				},
				branchCompany: [],
				pageType: '',
				dialogVisible:false,
				//提示bug弹窗
				dialogVisibleShenhe:false,
				//复制弹窗
				dialogVisibleFuzhi:false,
				//审核弹窗提示内容
				bugContentList:[],
				tabPosition:'88',
				load_data: false,
				iscenter: {
					textAlign: 'center',
					background: '#f8f8f8',
					color: '#232323',
				},
				currentPage: 1,
				size: 10,
				//page total
				count: 1,
				//已选数量
				piece: 0,
				//是否全选
				checkAll: false,
				tableList: [],
				arrOld: [],
				//公司
				sonCompanyList: [],
				//部门
				departmentList: [],
				//角色
				groupList: [],
				//店铺
				staffList: [],
				loadingStatus: '',
				platform: [
					{"sellerType":1,"itemTypeName":"Amazon"},{"sellerType":2,"itemTypeName":"Shopify"},{"sellerType":5,"itemTypeName":"Shoplazza"},{"sellerType":7,"itemTypeName":"Shopline"}
				],
				platforms:[],
				bizhong:'',
				dialogDBVisible: false,
				netWorkData: [],
			}
		},
		created() {
			this.sellerId = ''
			this.markShopId = ''
			this.str = JSON.parse(localStorage.getItem('role'))
			this.rid = this.str.rid
			this.selectForm.staffId = this.str.rid
			this.selectForm.companyId = this.str.company_id
			this.strSeller = JSON.parse(localStorage.getItem('sellerInfo'))
			this.show = this.str.system
			this.system = this.str.system
			this.state = this.str.system
            this.init()
			//获取表格数据
			this.get_table_data()
			//不知道
			// ajaxPost(API, paramsData)
			// 		.then((res) => {
			// 			if(res.data.code === 200) {
			// 				this.platforms = res.data.data
			// 			}else{
			// 				this.platform=[]
			// 				this.$message.error(res.data.data)
			// 			}
			// 		})
		},
		methods: {
			openAiView(){
				const arr = this.netWorkData.filter(item => item.state).map(item => item.sku);
				if(arr.length == 0){
					this.$message.error('请选择商品')
					return
				}
				const params = {
					skus: arr
				}
				window.open('#/AIAssisted?params=' + encodeURIComponent(JSON.stringify(params)), '_blank');
			},
			citationDatabase(){
				this.dialogDBVisible = true;
			},
			searchNetworkData(){
				if(!this.searchTerm && !this.shopLink && !this.sku){
					this.$message.warning('请输入其中一项')
					return
				}
				const params = {}
				if(this.searchTerm){
					params['searchTerm'] = this.searchTerm;
				}
				if(this.shopLink){
					params['shopLink'] = this.shopLink;
				}
				if(this.sku){
					params['skus'] = this.sku.split(',');
				}
				this.mainImages = [];
				this.otherImages = [];
				ajaxPost(Baseurl + 'amazonProductCrawl/getPriceAndImageBySearchTerm', params).then((response)=>{
					if (response.status == 200 && response.data && response.data.code == 200) {
						const data = response.data.data;
						if(data.length == 0){
							this.$message.warning('没有查询到数据')
						}
						this.netWorkData = data;
					}
				})
			},
			changeState(row){
				this.$set(row, 'state', !row.state)
			},
            init() {
                this.loadingStatus = true
                ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
                    rid: this.str.rid,
                    system: this.str.system,
                    companyId: this.str.company_id,
                    sellerType: this.sellerType
                }).then((res) => {
                    this.arr = res.data.data.next
					const { type: companyType } = this.str
                    if (
                        companyType === 1 &&
                        this.str.superDepartmentName !== '客服部' &&
                        this.str.superDepartmentName !== '常规客服部'
                    ) {
                        this.disabledInput2 = false
                        this.disabledInput3 = false
                        this.disabledInput4 = false
                        this.arr6 = res.data.data.next
                    } else if (
                        companyType === 2 ||
                        (companyType === 1 &&
                            this.str.superDepartmentName === '客服部') ||
                        (companyType === 1 &&
                            this.str.superDepartmentName === '常规客服部')
                    ) {
                        this.disabledInput2 = false
                        this.disabledInput3 = false
                        this.disabledInput4 = false
                        this.arr7 = res.data.data.next
                    } else if (
                        this.state === 1 ||
                        (this.str.type === 3 &&
                            this.str.system === 5 &&
                            this.str.superDepartmentName === '财务部') ||
                        (this.str.type === 3 &&
                            this.str.system === 5 &&
                            this.str.superDepartmentName === '人事部')
                    ) {
                        this.disabledInput = false
                        this.disabledInput2 = false
                        this.disabledInput3 = false
                        this.disabledInput4 = false
                        this.arr1 = res.data.data.next
                    } else if (this.state === 2) {
                        this.disabledInput = true
                        this.disabledInput2 = false
                        this.disabledInput3 = false
                        this.disabledInput4 = false
                        this.arr1 = res.data.data.next
                    } else if (this.state === 3) {
                        this.disabledInput = true
                        this.disabledInput2 = true
                        this.disabledInput3 = false
                        this.disabledInput4 = false
                        this.arr2 = res.data.data.next
                    } else if (this.state === 4) {
                        this.disabledInput = true
                        this.disabledInput2 = true
                        this.disabledInput3 = true
                        this.disabledInput4 = false
                        this.arr3 = res.data.data.next
                    } else if (this.state === 5) {
                        this.disabledInput = true
                        this.disabledInput2 = true
                        this.disabledInput3 = true
                        this.disabledInput4 = true
                        var sellerInfos = res.data.data.next
                        var newArr = []
                        var num = 0
                        for (var i = 0; i < sellerInfos.length; i++) {
                            var shop = sellerInfos[i].countryMarks
							var sellerId = sellerInfos[i].sellerId;
							var currencyCode = sellerInfos[i].currencyCode;
                            for (var j = 0; j < shop.length; j++) {
								shop[j].sellerId = sellerId;
								shop[j].currencyCode = currencyCode;
                                newArr[num] = shop[j]
                                // newArr[num] = shop[j];
                                num++
                            }
                        }
                        this.arr4 = newArr
                        // this.arr4 = newArr.sort((a, b) => a.order - b.order);
                    }
                })
            },
			calculationDate(type = 0) {
				const date = new Date()
				const year = date.getFullYear()
				const month = date.getMonth() + 1
				const day = date.getDate()
				// 计算新的月份和年份，确保处理负数和跨年的情况
				const newYear = year + Math.floor((month + type - 1) / 12);
				const newMonth = (month + type - 1 + 12) % 12 + 1;
				this.selectForm.startTime = `${newYear}-${newMonth.toString().padStart(2, '0')}-01 00:00:00`;

				const prevStamp = new Date(year, month + type, day).getTime() - (3600 * 1000 * 24 * day)
				const prevMonth = `${new Date(prevStamp).getFullYear()}-${new Date(prevStamp).getMonth() + 1}-${new Date(prevStamp).getDate()}`
				this.selectForm.endTime = `${prevMonth} 23:59:59`
			},
			changeCurrencyCode(val){
				console.log(val);
				this.bizhong = val;
				this.$refs.bianti.bizhong = val;
			},
			//获取表格数据
			get_table_data() {
				var that = this
				this.load_data = true
				var begin = this.selectForm.startTime
				if (begin == null || begin == '') {
					begin = ''
				} else {
					begin =
							new Date(this.selectForm.startTime)
									.toLocaleDateString()
									.replace(/\//g, '-') +
							' ' +
							new Date(this.selectForm.startTime)
									.toTimeString()
									.substr(0, 8)
				}
				var end = this.selectForm.endTime
				if (end == null || end == '') {
					end = ''
				} else {
					end =
							new Date(this.selectForm.endTime)
									.toLocaleDateString()
									.replace(/\//g, '-') +
							' ' +
							new Date(this.selectForm.endTime).toTimeString().substr(0, 8)
				}
				this.loadingStatus = true
				//将startTime格式强转
				let searchobj  =Object.assign({}, this.selectForm, {
					startTime:begin,
					endTime:end,
					page: this.currentPage,
					size: this.size,
				})
				ajaxPost(Baseurl + 'ozonProduct/selectOzonProducts', searchobj).then(
						(res) => {
							this.load_data = false
							const { code, message, data } = res.data
							if (code == 200) {
								this.tableList = data.list.map(item => {
									item.isShowAll = false
									item.images = JSON.parse(item.images)
									return item
								})
								this.count = data.total
							} else {
								this.$message.error(message)
							}
						}
				).catch(function(e) {
				})
			},
			// 条件搜索
			search() {
				this.currentPage = 1
				this.get_table_data()
			},
			//下拉选变化
			selectChange(event, type) {
				if (type === 'sonCompanyList') {
				} else if (type === 'departmentList') {
				} else if (type === 'groupList') {
				} else if (type === 'staffList') {
				}
			},
			//重置
			resetForm(formName) {
				this.$refs[formName].resetFields()
				this.sonCompany = []
				this.departmentList = []
				this.groupList = []
				this.staffList = []
				this.get_table_data()
			},
			//修改size
			handleSizeChange(val) {
				this.size = val
				this.get_table_data()
			},
			//修改current
			handleCurrentChange(val) {
				this.currentPage = val
				this.get_table_data()
			},
			// 选中框
			Selection(item) {
				this.arrOld.push(item.id)
				if (item.chatype) {
					this.piece++
				} else {
					this.piece--
				}
				if (this.tableList.length > this.piece) {
					this.checkAll = false
				} else {
					this.checkAll = true
				}
			},
			//左侧勾选项变化
			on_batch_select(val) {
				var newarr = []
				this.piece = val.length
				for (var i = 0; i < val.length; i++) {
					newarr.push(val[i].id)
				}
				this.batch_select = newarr
			},
			//审核提示
			clickBugTip(val){
				this.bugContentList = val
				this.dialogVisibleShenhe = true
			},
			//创建产品
			addNewProduct(){
				this.isEdit = false
				this.title = '添加产品'
				this.dialogVisible = true
				this.$nextTick(() => {
					this.$refs.baseInfo.addStatus = 'add'
					this.$refs.baseInfo.setDianpuList(this.arr4)
					this.$refs.bianti.bizhong = this.bizhong
					this.resetPage()
				});
			},
			//重置各页面参数
			resetPage(){
				this.$refs.baseInfo.isEditLeimu = false
				this.$refs.baseInfo.formData.shopId = undefined
				this.$refs.baseInfo.formData.sellerId = undefined
				this.$refs.baseInfo.formData.name = undefined
				this.$refs.baseInfo.allLeimuName = undefined
				this.$refs.baseInfo.formData.sku = undefined
				this.$refs.baseInfo.formData.categoryId = undefined
				this.$refs.baseInfo.formData.typeId = undefined
				this.$refs.description.formData.descValue = undefined
				this.$refs.description.formData.description = undefined
				this.$refs.description.formData.jsonDescription = undefined
				this.$refs.description.formData.jsonValue = undefined
				this.$refs.description.formData.chicunDescription = undefined
				this.$refs.description.formData.chicunValue = undefined
				this.$refs.description.isShowJson = false
				this.$refs.description.isShowChicun = false
				this.$refs.laiyuan.formData.remark = undefined
				this.$refs.laiyuan.blue_point = [{
					value: undefined,
					type: true,
				}]
				this.$refs.shipin.formData.title = undefined
				this.$refs.shipin.formData.biaotiDescription = undefined
				this.$refs.shipin.formData.chanpinDescription = undefined
				this.$refs.shipin.formData.fengmianDescription = undefined
				this.$refs.shipin.chanpinUrl = ''
				this.$refs.shipin.fengmianUrl = ''
				this.$refs.uploadPictures.imgListSelect = []
				this.$refs.wuliu.formData.depth = undefined
				this.$refs.wuliu.formData.height = undefined
				this.$refs.wuliu.formData.vat = '0'
				this.$refs.wuliu.formData.weight = undefined
				this.$refs.wuliu.formData.width = undefined
				this.$refs.wuliu.formData.warehouseId = undefined
				this.$refs.bianti.ParentSKU = undefined
				this.$refs.bianti.ParentName = undefined
				this.$refs.bianti.tableList =[{
					name:'',
					oldPrice:'',//原价
					price:'',//现价
					stock:'',//库存
					isShowImage:false,//是否展示输入框按钮
					offerId:'',//卖家产品id(自定义sku) 父sku拼接颜色/尺寸等
					primaryImage:'', //主图
					imageList:[],
					colorImage:'',//营销色彩
				}]
				this.$refs.bianti.headerList =[]
				this.$refs.bianti.attrErweiList =[]
			},
			//复制产品
			copyProduc(row){
				if (!row && this.piece == 0){
					this.$alert('请至少勾选一件产品！', '提示', {
						confirmButtonText: '确定',
					})
					return
				}
            	if (row){
					this.fuzhiId = row.id
				} else {
					this.fuzhiId = ''
				}
				this.fuzhiDianpuObj = {}
				this.warehouseId = ''
				this.dialogVisibleFuzhi = true
			},
			//删除产品
			deleteProduct(row){
				var that = this
				if (this.piece == 0 && !row) {
					this.$alert('请至少勾选一件产品！', '提示', {
						confirmButtonText: '确定',
					})
				} else {
					this.$confirm('此操作将永久删除该产品, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					})
							.then(() => {
								let params ={
									ids: row ? [row.id]:that.batch_select
								}
								ajaxPost(
										Baseurl + 'ozonProduct/batchDeleteOzonProduct',
										params
								).then((res) => {
									if (res.data.code == 200) {
										that.$message({
											type: 'success',
											message: '删除成功!',
										})
										that.get_table_data()
									}
								})
							})
							.catch(() => {
								this.$message({
									type: 'info',
									message: '已取消删除',
								})
							})
				}
			},
			//发布产品
			displayProduc(row){
				var that = this
				if (this.piece == 0 && !row) {
					this.$alert('请至少勾选一件产品！', '提示', {
						confirmButtonText: '确定',
					})
				} else {
					this.$confirm('此操作将发布产品, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					})
							.then(() => {
								ajaxPost(
										Baseurl + 'ozonProduct/batchReleaseOzonProduct',
										{
											ids: row ? [row.id]:that.batch_select
										}
								).then((res) => {
									if (res.data.code == 200) {
										that.$message({
											type: 'success',
											message: '发布成功!',
										})
										that.get_table_data()
									}
								})
							})
							.catch(() => {
								this.$message({
									type: 'info',
									message: '已取消删除',
								})
							})
				}
			},
			//同步产品
			tbProduc(row){
				var that = this
				if (this.piece == 0 && !row) {
					this.$alert('请至少勾选一件产品！', '提示', {
						confirmButtonText: '确定',
					})
				} else {
					//这里应该写一个状态不一致的判断逻辑并给提示
					// if (!row){
					//
					// }

					this.$confirm('此操作将同步产品该产品, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					})
							.then(() => {
								ajaxPost(
										Baseurl + 'ozonProduct/batchDeleteOzonProduct',
										{
											ids: row ? [row.id]:that.batch_select
										}
								).then((res) => {
									if (res.data.code == 200) {
										that.$message({
											type: 'success',
											message: '同步成功!',
										})
										that.get_table_data()
									}
								})
							})
							.catch(() => {
								this.$message({
									type: 'info',
									message: '已取消删除',
								})
							})
				}
			},
			// 产品图片子组件 中上传的图片列表
			ImgList(ImgList) {
				this.productImgArr = ImgList
			},
			downloadImgs() {
				const API =
						Baseurl + 'imageController/downlowndImage?id=' + this.productId
				ajaxPost(API)
						.then((res) => {
							const { code, data } = res.data
							if (code === 200) {
								const AElement = document.createElement('a')
								AElement.href = data
								AElement.click()
								this.$message.success('正在下载...')
							}
						})
						.catch(() => {
							this.$message.error('下载失败...')
						})
			},
			//增加变体信息
			addToBianti(item){
				this.$refs.bianti.addBianti(item)
			},
			//设置变体信息
			setBiantiList(list) {
				this.$refs.bianti.setBiantiList(list)
			},
			//设置变体信息
			setBiantiList2(list,list2) {
				this.$refs.bianti.setBiantiList2(list,list2)
			},
			//编辑切换类目后，需要重置主属性、变体属性及其他值
			resetBianti() {
				this.$refs.laiyuan.formData.remark = undefined
				this.$refs.laiyuan.blue_point = [{
					value: undefined,
					type: true,
				}]
				this.$refs.shipin.formData.title = undefined
				this.$refs.shipin.formData.biaotiDescription = undefined
				this.$refs.shipin.formData.chanpinDescription = undefined
				this.$refs.shipin.formData.fengmianDescription = undefined
				this.$refs.shipin.chanpinUrl = ''
				this.$refs.shipin.fengmianUrl = ''
				this.$refs.shipin.isShowBiaoti = false
				this.$refs.shipin.isShowChanpin = false
				this.$refs.shipin.isShowFengmian = false
				this.$refs.wuliu.formData.depth = undefined
				this.$refs.wuliu.formData.height = undefined
				this.$refs.wuliu.formData.vat = '0'
				this.$refs.wuliu.formData.weight = undefined
				this.$refs.wuliu.formData.width = undefined
				this.$refs.wuliu.formData.warehouseId = undefined
				this.$refs.description.formData.descValue = undefined
				this.$refs.description.formData.description = undefined
				this.$refs.description.formData.jsonDescription = undefined
				this.$refs.description.formData.jsonValue = undefined
				this.$refs.description.formData.chicunDescription = undefined
				this.$refs.description.formData.chicunValue = undefined
				this.$refs.description.isShowJson = false
				this.$refs.description.isShowChicun = false
				this.$refs.bianti.resetBianti()
			},
			editDescJson(item,type){
				this.$refs.description.editDescJson(item,type)
			},
			editShipinDesc(item,type){
				this.$refs.shipin.editSpDesc(item,type)
			},
			//修改仓库list
			editCangku(arr){
				this.$refs.wuliu.editCangku(arr)
			},
			shopChange2(value2) {
				this.arr3 = []
				this.arr4 = []
				this.arr5 = []
				this.value3 = ''
				this.value4 = ''
				this.value5 = ''
				this.rid = value2.rid
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: value2.rid,
					system: 3,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					this.arr2 = res.data.data.next
					this.shopIds = res.data.data.shopIds
				})
			},
			shopChange3(value3) {
				this.arr4 = []
				this.arr5 = []
				this.value4 = ''
				this.value5 = ''
				this.rid = value3.rid
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: value3.rid,
					system: 4,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					this.arr3 = res.data.data.next
					this.shopIds = res.data.data.shopIds
				})
			},
			shopChange4(value4) {
				this.arr5 = []
				this.value5 = ''
				this.rid = value4.rid
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: value4.rid,
					system: 5,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					var sellerInfos = res.data.data.next
					var newArr = []
					var ids = []
					var num = 0
					// for (var i = 0; i < sellerInfos.length; i++) {
					// 	var shop = sellerInfos[i].countryMarks;
					// 	var currencyCode = sellerInfos[i].currencyCode;
					// 	for (var j = 0; j < shop.length; j++) {
					// 		shop[j].currencyCode = currencyCode;
					// 		newArr[num] = shop[j]
					// 		ids[num] = shop[j].shopId
					// 		num++
					// 	}
					// }

					for (var i = 0; i < sellerInfos.length; i++) {
						var shop = sellerInfos[i].countryMarks
						var sellerId = sellerInfos[i].sellerId;
						var currencyCode = sellerInfos[i].currencyCode;
						for (var j = 0; j < shop.length; j++) {
							shop[j].sellerId = sellerId;
							shop[j].currencyCode = currencyCode;
							newArr[num] = shop[j]
							// newArr[num] = shop[j];
							num++
						}
					}
					this.arr4 = newArr
					this.shopIds = res.data.data.shopIds
				})
			},
			shopChange5(value5) {
				// this.sellerIds = item;
				// this.rid = ''
				this.shopIds = [value5.shopId]
				this.markShopId =value5.shopId
				this.selectForm.sellerId = value5.sellerId
			},
			shopChange6(value6) {
				this.arr1 = []
				this.arr2 = []
				this.arr3 = []
				this.arr4 = []
				this.arr5 = []
				this.arr7 = []
				this.value1 = ''
				this.value2 = ''
				this.value3 = ''
				this.value4 = ''
				this.value5 = ''
				this.value7 = ''
				this.selectForm.companyId = value6.company_id
				this.rid = value6.rid
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: value6.rid,
					system: 1,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.arr7 = data.next
						this.shopIds = data.shopIds
						this.getCompanyMoney()
					}
				})
			},
			shopChange7(value7) {
				this.arr1 = []
				this.arr2 = []
				this.arr3 = []
				this.arr4 = []
				this.arr5 = []
				this.value1 = ''
				this.value2 = ''
				this.value3 = ''
				this.value4 = ''
				this.value5 = ''
				this.selectForm.companyId = value7.company_id
				this.sellerType='';
				this.rid = value7.rid
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: value7.rid,
					system: 1,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.arr1 = data.next
						this.shopIds = data.shopIds
						this.getCompanyMoney()
					}
				})
				this.getItemList();
			},
			shopChange8() {
				// if(this.arr4.length != 0) {
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: this.rid,
					system: this.str.system,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					// var sellerInfos = res.data.data.next
					// var newArr = []
					// var ids = []
					// var num = 0
					// for (var i = 0; i < sellerInfos.length; i++) {
					// 	var shop = sellerInfos[i].countryMarks
					// 	for (var j = 0; j < shop.length; j++) {
					// 		newArr[num] = shop[j]
					// 		ids[num] = shop[j].shopId
					// 		num++
					// 	}
					// }
					if (
							this.state === 1 ||
							(this.str.type === 3 &&
									this.str.system === 5 &&
									this.str.superDepartmentName === '财务部') ||
							(this.str.type === 3 &&
									this.str.system === 5 &&
									this.str.superDepartmentName === '人事部')
					) {
						this.arr1 = res.data.data.next
						this.arr2 = []
						this.arr3 = []
						this.arr4 = []
						this.arr5 = []
						this.value2 = ''
						this.value3 = ''
						this.value4 = ''
						this.value5 = ''
					} else if(this.state === 2) {
						this.arr1 = res.data.data.next
						this.arr2 = []
						this.arr3 = []
						this.arr4 = []
						this.arr5 = []
						this.value2 = ''
						this.value3 = ''
						this.value4 = ''
						this.value5 = ''
					}else if(this.state === 3) {
						this.arr2 = res.data.data.next
						this.arr3 = []
						this.arr4 = []
						this.arr5 = []
						this.value3 = ''
						this.value4 = ''
						this.value5 = ''
					}else if(this.state === 4) {
						this.arr3 = res.data.data.next
						this.arr4 = []
						this.arr5 = []
						this.value4 = ''
						this.value5 = ''
					}else if(this.state === 5) {
						var sellerInfos = res.data.data.next
						var newArr = []
						var num = 0
						// for (var i = 0; i < sellerInfos.length; i++) {
						// 	var shop = sellerInfos[i].countryMarks;
						// 	var currencyCode = sellerInfos[i].currencyCode;
						// 	for (var j = 0; j < shop.length; j++) {
						// 		shop[j].currencyCode = currencyCode;
						// 		newArr[num] = shop[j]
						// 		// newArr[num] = shop[j];
						// 		num++
						// 	}
						// }

						for (var i = 0; i < sellerInfos.length; i++) {
                            var shop = sellerInfos[i].countryMarks
							var sellerId = sellerInfos[i].sellerId;
							var currencyCode = sellerInfos[i].currencyCode;
                            for (var j = 0; j < shop.length; j++) {
								shop[j].sellerId = sellerId;
								shop[j].currencyCode = currencyCode;
                                newArr[num] = shop[j]
                                // newArr[num] = shop[j];
                                num++
                            }
                        }
						this.arr4 = newArr
						this.arr5 = []
						this.value5 = ''
					}
					this.shopIds = res.data.data.shopIds
				})
				// }
			},

			Search2() {
				this.currentPage = 1
				this.get_table_data()
			},
			// 重置
			searchReset() {
            	this.selectForm.startTime = undefined
				this.selectForm.endTime = undefined
				this.selectForm.searchStr = undefined
				this.selectForm.searchType = '1'
				this.selectForm.sellerId = ''

				this.input = ''
				this.selectForm.Ymxvalue = ''
				this.selectForm.demandValue = ''
				this.selectForm.purchaseValue = ''
				this.selectForm.domesticvalue = ''
				this.selectForm.domesticLogisticsStatus = ''
				this.selectForm.internationalLogisticsStatus = ''
				this.selectForm.purchaseEstimated = ''
				this.selectForm.logisticsEstimated = ''
				this.selectForm.channelStatus = ''
				this.selectForm.countryMark = ''
				// this.selectForm.startTime = ''
				// this.selectForm.endTime = ''
				this.selectForm.systemSku = ''
				this.selectForm.sku = ''

				this.selectForm.resource1 = ''
				this.selectForm.resource2 = ''
				this.selectForm.resource3 = ''
				this.selectForm.resource4 = ''
				;(this.purchaseMark = ''),
						(this.channelMark = ''),
						(this.orderMark = '')
				this.orderType = '';
				this.currentPage = 1
				this.size = 20
				this.arr1 = []
				this.arr2 = []
				this.arr3 = []
				this.arr4 = []
				this.arr5 = []
				this.arr6 = []
				this.arr7 = []
				// this.value1 = "";
				this.value2 = ''
				this.value3 = ''
				this.value4 = ''
				this.value5 = ''
				this.value6 = ''
				this.value7 = ''
				this.sellerType = ''

				this.orderStatus = ''
				this.purchaseDemandStatus = ''

				this.selectForm.internalConveyNumber = ''
				this.selectForm.conveyNumber = ''

				var str = JSON.parse(localStorage.getItem('role'))
				this.state = str.system
				this.rid = str.rid
				this.init()
				this.get_table_data()
			},
			getCompanyMoney() {
				const API =
						Baseurl + 'companyController/selectCompanyBalanceByCompanyId'
				const paramsData = { id: this.selectForm.companyId }

				ajaxPost(API, paramsData).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.companyInfo = data
					}
				})
			},

			//选择开始时间
			startTime(val) {
				var d = new Date(val)
				var datetime =
						d.getFullYear() +
						'-' +
						(d.getMonth() + 1) +
						'-' +
						d.getDate() +
						' 00:00:00'
				this.selectForm.startTime = datetime
			},
			// 选择结束时间
			endTime(val) {
				var d = new Date(val)
				var datetime =
						d.getFullYear() +
						'-' +
						(d.getMonth() + 1) +
						'-' +
						d.getDate() +
						' 23:59:59'
				this.selectForm.endTime = datetime
			},
			//修改状态，请求数据接口
			changeStatus(){
				this.currentPage = 1
            	this.get_table_data()
			},
			clickFuzhi(){
				this.dialogVisibleFuzhi = false
				this.load_data = true
				var that = this
				let params ={
					ids: that.fuzhiId? [that.fuzhiId]: that.batch_select,
					sellerId: that.fuzhiDianpuObj.sellerId,
					countrySellerId:that.fuzhiDianpuObj.shopId,
					warehouseId:that.warehouseId
				}
				ajaxPost(Baseurl + 'ozonProduct/copyOzonProduct', params).then((res) => {
					this.load_data = false
					if (res.data.code == 200) {
						this.$message({
							type: 'success',
							message: '复制成功!',
						})
						this.get_table_data()
					} else {
						this.$message({
							type: 'error',
							message: res.data.message,
						})
					}
				})
			},
			changeDianpuId(val){
            	if (val){
					this.warehouseIdList = []
					this.fuzhiDianpuObj = val
					//通过商铺id获取仓库雷柏
					const API =
							Baseurl + 'ozonProduct/getOzonWarehouseList'
					const paramsData = { sellerId: val.sellerId}
					ajaxPost(API, paramsData).then((res) => {
						const { code, data } = res.data
						if (code === 200) {
							this.warehouseIdList = data
						}
					})
				} else {
					this.fuzhiDianpuObj = {}
					this.warehouseId = ''
					this.warehouseIdList = []
				}
			},	// 产品图片子组件 响应 变体信息子组件 中上传的图片
			addImg(file) {
				this.$refs.uploadPictures.addImg(file)
			},
			addImageList(imageList){
				this.$refs.uploadPictures.biantiaddImgList(imageList)
			},
			//修改reamrk
			changeReamrk(val){
				this.$refs.laiyuan.formData.remark = val
			},
			//子项点击移除变体
			changeTopAttr(attrList){
				this.$refs.baseInfo.addTopAttrList(attrList)
			},
			//返回一共有多少个输入框
			returnInputLength(){
            	//input 总个数
				let inputLength = 13
				//必填总个数 包括图片
				let bitianLength = 11
				if (this.$refs.description.isShowJson){
					inputLength += 1
				}
				if (this.$refs.description.isShowChicun){
					inputLength += 1
				}
				//视频标题
				if (this.$refs.shipin.isShowBiaoti){
					inputLength += 1
				}
				//产品视频
				if (this.$refs.shipin.isShowChanpin){
					inputLength += 1
				}
				//封面视频
				if (this.$refs.shipin.isShowBiaoti){
					inputLength += 1
				}
				//变体输入框个数
				let tableLength = (6 + this.$refs.bianti.headerList.length) * this.$refs.bianti.tableList.length
				let bitianTableLength = (6 + this.$refs.bianti.headerList.filter(item =>{
					return item.isRequired == 1
				}).length) * this.$refs.bianti.tableList.length
				//固定长度加 来源url长度
				inputLength = inputLength + this.$refs.laiyuan.blue_point.length + tableLength + this.$refs.baseInfo.topAttributeList.length
				bitianLength = bitianLength + bitianTableLength + this.$refs.baseInfo.topAttributeList.filter(item => {
					return item.isRequired == 1
				}).length
				//以下代码计算输入值长度
				//输入个数
				let shuruInputLength = 0
				//必填输入个数
				let shuruBitianLength = 0
				//店铺
				if (this.$refs.baseInfo.formData.sellerId){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				//类目
				if (this.$refs.baseInfo.allLeimuName){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				//sku
				if (this.$refs.baseInfo.formData.sku){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				//标题
				if (this.$refs.baseInfo.formData.name){
					shuruInputLength += 1
					shuruBitianLength += 1
				}

				//视频标题
				if (this.$refs.shipin.isShowBiaoti && this.$refs.shipin.formData.title){
					shuruInputLength += 1
				}
				//产品视频
				if (this.$refs.shipin.isShowChanpin && this.$refs.shipin.chanpinUrl){
					shuruInputLength += 1
				}
				//封面视频
				if (this.$refs.shipin.isShowFengmian && this.$refs.shipin.fengmianUrl){
					shuruInputLength += 1
				}
				if (this.$refs.baseInfo.topAttributeList.length > 0){
					this.$refs.baseInfo.topAttributeList.forEach(item =>{
						if (item.dictionaryId == 0&& (item.fieldValue || item.fieldValue == 'false' || item.fieldValue == '0')){
							shuruInputLength += 1
							if (item.isRequired == '1'){
								shuruBitianLength += 1
							}
						}
						if (item.dictionaryId != 0 && item.isCollection == 0 && (item.fieldValue || item.fieldValue == 0)){
							shuruInputLength += 1
							if (item.isRequired == '1'){
								shuruBitianLength += 1
							}
						}
						if (item.dictionaryId != 0  && item.isCollection == 1 && item.fieldValue && item.fieldValue.length > 0){
							//有值输入值加1
							shuruInputLength += 1
							if (item.isRequired == '1'){
								shuruBitianLength += 1
							}
						}
					})
				}
				//文字描述
				if (this.$refs.description.formData.descValue){
					shuruInputLength += 1
				}
				//json
				if (this.$refs.description.isShowJson && this.$refs.description.formData.jsonValue){
					shuruInputLength += 1
				}
				//尺寸表
				if (this.$refs.description.isShowChicun && this.$refs.description.formData.chicunValue){
					shuruInputLength += 1
				}
				//来源url
				for (let i = 0; i < this.$refs.laiyuan.blue_point.length; i++) {
					if (this.$refs.laiyuan.blue_point[i].value){
						shuruInputLength += 1
					}
				}
				//备注
				if (this.$refs.laiyuan.formData.remark){
					shuruInputLength += 1
				}
				//仓库
				if (this.$refs.wuliu.formData.warehouseId){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				//增值
				if (this.$refs.wuliu.formData.vat || this.$refs.wuliu.formData.vat == '0'){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				//重量
				if (this.$refs.wuliu.formData.weight){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				//长
				if (this.$refs.wuliu.formData.width){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				//宽
				if (this.$refs.wuliu.formData.height){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				//高
				if (this.$refs.wuliu.formData.depth){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				if(this.$refs.uploadPictures.imgListSelect && this.$refs.uploadPictures.imgListSelect.length > 0){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				this.$refs.bianti.tableList.forEach(item => {
					//图片
					if (item.imageList && item.imageList.length > 0){
						shuruInputLength += 1
						shuruBitianLength += 1
					}
					//sku
					if (item.name){
						shuruInputLength += 1
						shuruBitianLength += 1
					}
					//sku
					if (item.offerId){
						shuruInputLength += 1
						shuruBitianLength += 1
					}
					//售价
					if (item.price || item.price == '0'){
						shuruInputLength += 1
						shuruBitianLength += 1
					}
					//原价
					if (item.oldPrice || item.oldPrice == '0'){
						shuruInputLength += 1
						shuruBitianLength += 1
					}
					//库存
					if (item.stock || item.stock == '0'){
						shuruInputLength += 1
						shuruBitianLength += 1
					}
				})
				this.$refs.bianti.attrErweiList.forEach((item, idx) =>{
					item.forEach((itemAttr,index) => {
						//input
						if (this.$refs.bianti.headerList[idx].dictionaryId == '0' && (itemAttr.value || itemAttr.value == '0' || itemAttr.value == 'false')){
							//必填
							if (this.$refs.bianti.headerList[idx].isRequired == '1'){
								shuruBitianLength += 1
							}
							shuruInputLength += 1
						}
						//单选
						if (this.$refs.bianti.headerList[idx].dictionaryId != 0 && this.$refs.bianti.headerList[idx].isCollection == 0  && (itemAttr.value || itemAttr.value == '0' || itemAttr.value == 'false') ){
							//必填
							if (this.$refs.bianti.headerList[idx].isRequired == '1'){
								shuruBitianLength += 1
							}
							shuruInputLength += 1
						}
						//多选
						if (this.$refs.bianti.headerList[idx].dictionaryId != 0  && this.$refs.bianti.headerList[idx].isCollection == 1 && itemAttr.value && itemAttr.value.length > 0){
							//必填
							if (this.$refs.bianti.headerList[idx].isRequired == '1'){
								shuruBitianLength += 1
							}
							shuruInputLength += 1
						}
					})
				})

				return{
					inputLength:inputLength,
					bitianLength:bitianLength,
					shuruInputLength:shuruInputLength,
					shuruBitianLength:shuruBitianLength,
					bitian:bitianLength == shuruBitianLength,
					wanchengdu:(shuruInputLength/inputLength*100).toFixed(2)
				}
			},
			//保存按钮
			saveChanpin(isFabu){
				let inputBitianObj = this.returnInputLength()
				this.$refs.bianti.createName()
				//检测是否有变体重复，有的话，标红
				if (this.$refs.bianti.returnBianti()){
					this.$message('变体信息不可重复，请修改变体属性')
					return
				}

            	if(!this.$refs.baseInfo.formData.sku){
            		this.$message('父SKU不能为空')
					return
				}
				if(!this.$refs.baseInfo.allLeimuName){
					this.$message('分类选择不能为空')
					return
				}
				if(this.$refs.bianti.tableList.some(item => {
					return !item.offerId
				})){
					this.$message('变体属性SKU不能为空')
					return
				}
				//判断变体是否重复的
				let isChongfuBianti = ([...new Set(this.$refs.bianti.attrErweiList)].length == this.$refs.bianti.attrErweiList.length)
				if (!isChongfuBianti){
					this.$message('变体属性重复，不可提交')
					return
				}
				this.saveLoadding = true
				let attributesJsonArray = this.$refs.baseInfo.topAttributeList.map(item =>{
					let isZhi = false
					let values = []
					//输入框
					if(item.dictionaryId == 0){
						if (item.fieldValue || item.fieldValue == '0' || item.fieldValue == 'false' ){
							isZhi = true
							if (item.type == 'Boolean'){
								values= [{value:item.fieldValue == true ? true:false}]
							} else if (item.type == 'Integer'){
								values= [{value:parseInt(item.fieldValue)}]
							} else if(item.type == 'Decimal'){
								values= [{value:parseFloat(item.fieldValue)}]
							} else {
								values= [{value:item.fieldValue}]
							}
						} else {
							isZhi = false
							values = []
						}
					}
					//单选
					if (item.dictionaryId != 0 && item.isCollection == 0){
						if (item.fieldValue || item.fieldValue == '0'){
							isZhi = true
							let valueObj = item.attributeValues.filter(itemattrs =>{
								return itemattrs.value == item.fieldValue
							})[0]
							values = [
								{
									dictionary_value_id:valueObj.valueId,
									value:valueObj.value
								}
							]
						} else {
							isZhi = false
							values = []
						}

					}
					//多选
					if (item.dictionaryId != 0 && item.isCollection == 1){
						if (item.fieldValue && item.fieldValue.length > 0){
							let ss = []
							item.attributeValues.forEach(itemattrs =>{
								if (item.fieldValue.some(iiField =>
									iiField == itemattrs.value
								)){
									ss.push(
											{
												dictionary_value_id:itemattrs.valueId,
												value:itemattrs.value
											}
									)
								}
							})
							values = ss
							isZhi = true
						} else {
							isZhi = false
							values = []
						}

						// values = [
						// 	{
						// 		dictionary_value_id:valueObj.valueId,
						// 		value:valueObj.value
						// 	}
						// ]
					}
					if (item.attributeId == '31' || item.attributeId == '85'){
						values=[{
							dictionary_value_id:'126745801',
							value:'Нет бренда'
						}]
					}
					if (item.attributeId == '33'){
						values=[{
							dictionary_value_id:'10079056',
							value:'Без серии'
						}]
					}
					return {
						complex_id: item.attributeComplexId,
						id: item.attributeId, //属性id
						isZhi:isZhi,
						values:values
					}
				})
				//baseInfo 有9048属性
				if (this.$refs.baseInfo.attr9048 && this.$refs.baseInfo.attr9048.attributeId){
					attributesJsonArray.push({
						complex_id: this.$refs.baseInfo.attr9048.attributeComplexId,
						id: this.$refs.baseInfo.attr9048.attributeId, //属性id
						isZhi:true,
						values:[{
							value:this.$refs.baseInfo.formData.sku
						}]
					})
				}
				//baseInfo 有8292属性
				if (this.$refs.baseInfo.attr8292 && this.$refs.baseInfo.attr8292.attributeId){
					attributesJsonArray.push({
						complex_id: this.$refs.baseInfo.attr8292.attributeComplexId,
						id: this.$refs.baseInfo.attr8292.attributeId, //属性id
						isZhi:true,
						values:[{
							value:this.$refs.baseInfo.formData.sku
						}]
					})
				}
				// if (item.attributeId == '9048' || item.attributeId == '8292'){
				// 	values=[{
				// 		value:this.$refs.baseInfo.formData.sku
				// 	}]
				// }
				let saveArr = attributesJsonArray.filter(item =>{
					return item.isZhi
				})
				//标题
				// if (this.$refs.baseInfo.formData.name){
				// 	saveArr.push({
				// 		complex_id: this.$refs.baseInfo.biaotiComplexId4180,
				// 		id: 4180,
				// 		values:[{value:this.$refs.baseInfo.formData.name}]
				// 	})
				// }
				//封面视频
				if (this.$refs.shipin.fengmianUrl){
					saveArr.push({
						complex_id: this.$refs.baseInfo.biaotiComplexId21845,
						id: 21845,
						values:[{value:this.$refs.shipin.fengmianUrl}]
					})
				}
				//产品视频
				if (this.$refs.shipin.chanpinUrl){
					saveArr.push({
						complex_id: this.$refs.baseInfo.biaotiComplexId21841,
						id: 21841,
						values:[{value:this.$refs.shipin.chanpinUrl}]
					})
				}
				//视频标题
				if (this.$refs.shipin.formData.title){
					saveArr.push({
						complex_id: this.$refs.baseInfo.biaotiComplexId21837,
						id: 21837,
						values:[{value:this.$refs.shipin.formData.title}]
					})
				}
				//文字描述 简介
				if (this.$refs.description.formData.descValue){
					saveArr.push({
						complex_id:this.$refs.baseInfo.biaotiComplexId4191,
						id: 4191,
						values:[{value:this.$refs.description.formData.descValue}]
					})
				}
				//尺寸表
				if (this.$refs.description.formData.chicunValue){
					saveArr.push({
						complex_id: this.$refs.baseInfo.biaotiComplexId13164,
						id: 13164,
						values:[{value:this.$refs.description.formData.chicunValue}]
					})
				}
				//丰富内容
				if (this.$refs.description.formData.jsonValue){
					saveArr.push({
						complex_id: this.$refs.baseInfo.biaotiComplexId11254,
						id: 11254,
						values:[{value:this.$refs.description.formData.jsonValue}]
					})
				}
				let BiantiArr = []
				let oldTableList
				//移除数组
				let ids = []
				//点击了移除
				if (this.$refs.bianti.isYichu){
					let tList = this.$refs.bianti.oldTableList.filter(item =>{
						return  !this.$refs.bianti.tableList.some(itemSome => {
							return itemSome.id == item.id
						})
					})
					ids = tList.map(item => {
						return item.id
					})
				}
				//遍历每一层tablelist
				this.$refs.bianti.tableList.forEach((item,index) =>{
					let aspectAttributesJsonArray = []
					let headerList = this.$refs.bianti.headerList
					let arrErweiList = this.$refs.bianti.attrErweiList
						let attributesJsonArray2 = 	headerList.map( (itemHeader,headerIndex) =>{
						let isZhi = false
						let values = []
						//输入框
						if(itemHeader.dictionaryId == 0){
							if (arrErweiList[index][headerIndex].value || arrErweiList[index][headerIndex].value == 0 || arrErweiList[index][headerIndex].value == false){
								isZhi = true
								if (itemHeader.type == 'Boolean'){
									values= [{value:arrErweiList[index][headerIndex].value == true ? true:false}]
								} else if (itemHeader.type == 'Integer'){
									values= [{value:parseInt(arrErweiList[index][headerIndex].value)}]
								} else if(itemHeader.type == 'Decimal'){
									values= [{value:parseFloat(arrErweiList[index][headerIndex].value)}]
								} else {
									values= [{value:arrErweiList[index][headerIndex].value}]
								}
							} else {
								isZhi = false
								values = []
							}
						}
						//单选
						if (itemHeader.dictionaryId != 0 && itemHeader.isCollection == 0){
							if (arrErweiList[index][headerIndex].value || arrErweiList[index][headerIndex].value == '0'){
								isZhi = true
								let valueObj = itemHeader.attributeValues.filter(itemattrs =>{
									return itemattrs.value == arrErweiList[index][headerIndex].value
								})[0]
								values = [
									{
										dictionary_value_id:valueObj.valueId,
										value:valueObj.value
									}
								]
							} else {
								isZhi = false
								values = []
							}

						}
						//多选
						if (itemHeader.dictionaryId != 0 && itemHeader.isCollection == 1){
							if (arrErweiList[index][headerIndex].value && arrErweiList[index][headerIndex].value.length > 0){
								let ss = []
								itemHeader.attributeValues.forEach((itemattrs,index3) =>{
									if (arrErweiList[index][headerIndex].value.some(iiField =>iiField == itemattrs.value)){
										ss.push(
												{
													dictionary_value_id:itemattrs.valueId,
													value:itemattrs.value
												}
										)
									}
								})
								values = ss
								isZhi = true
							} else {
								isZhi = false
								values = []
							}

							// values = [
							// 	{
							// 		dictionary_value_id:valueObj.valueId,
							// 		value:valueObj.value
							// 	}
							// ]
						}

						return {
							complex_id:itemHeader.attributeComplexId,
							id: itemHeader.attributeId, //属性id
							isZhi:isZhi,
							values:values
						}
					})
					//value是空数组也可以传值了
					aspectAttributesJsonArray = attributesJsonArray2
					// aspectAttributesJsonArray = attributesJsonArray2.filter(item =>{
					// 	return item.isZhi
					// })
					let imageUrl = (item.imageList && item.imageList.length > 0) ? item.imageList[0]:null
					let ss = {
						id:this.isEdit ? item.id:null,
						parentSku: this.$refs.baseInfo.formData.sku, //父sku
						name: item.name, //产品名称,标题 精细化后的
						aspectAttributesJsonArray: aspectAttributesJsonArray, //方面/变体属性
					//	complexAttributesJsonArray: [], //复合属性
						colorImage: this.$refs.bianti.checked ? imageUrl : '', //营销色彩-色彩样本
						primaryImage: imageUrl, //主图
						imageList: item.imageList, //图片列表
						offerId: item.offerId, //卖家产品id(自定义sku) 父sku拼接颜色/尺寸等
						oldPrice: this.returnNumber(item.oldPrice), //原价
					//	barcode: "", //ean/条形码
					//	premiumPrice: 0, //订阅客户价格
						price: this.returnNumber(item.price), //现价 BigDecimal
						stock: this.returnNumber(item.stock), //库存 Integer
						//sourceLinkList: [], //产品资源链接
						//images360: "", //图像组360  max:70张
						sellerId: this.$refs.baseInfo.formData.sellerId, //卖家id
						companyId: this.returnNumber(this.selectForm.companyId), //公司id
						staffId: this.selectForm.staffId, //角色id
						countrySellerId: this.returnNumber(this.$refs.baseInfo.formData.shopId), //站点id
						categoryId: this.returnNumber(this.$refs.baseInfo.formData.categoryId), //分类id(第二层分类的分类id)
						typeId: this.returnNumber(this.$refs.baseInfo.formData.typeId), //商品类型id

						//发布中传2，保存必填完成 1  未全部完成 0
						releaseStatus:!isFabu ? inputBitianObj.bitian ? '1' : '0': '3'
					}
					BiantiArr.push(ss)
				})

				let saveParams ={
					ozonProductNew:{
						sku:this.$refs.baseInfo.formData.sku,
						complexAttributesJsonArray:[],
						pdfListJsonArray:[],
						categoryId:this.returnNumber(this.$refs.baseInfo.formData.categoryId),//商品类型id父id
						typeId:this.returnNumber(this.$refs.baseInfo.formData.typeId),//商品类型id
						depth:this.returnNumber(this.$refs.wuliu.formData.depth),
						dimensionUnit:this.$refs.wuliu.formData.dimensionUnit,
						height:this.returnNumber(this.$refs.wuliu.formData.height),
						imageList:this.$refs.uploadPictures.imgListSelect,
						name:this.$refs.baseInfo.formData.name,//标题
						serviceType:'IS_CODE_SERVICE',
						vat:this.$refs.wuliu.formData.vat,
						weight:this.returnNumber(this.$refs.wuliu.formData.weight),
						weightUnit:this.$refs.wuliu.formData.weightUnit,
						width:this.returnNumber(this.$refs.wuliu.formData.width),
						warehouseId:this.returnNumber(this.$refs.wuliu.formData.warehouseId),
						currencyCode: this.bizhong,
						companyId:this.returnNumber(this.selectForm.companyId),
						staffId:this.selectForm.staffId,
						countrySellerId:this.$refs.baseInfo.formData.shopId,
						sellerId:this.$refs.baseInfo.formData.sellerId,
						attributesJsonArray:saveArr,
						sourceLinkList:this.$refs.laiyuan.blue_point.map(item =>{
							return item.value
						}),
						remarks:this.$refs.laiyuan.formData.remark,
						completeness:inputBitianObj.wanchengdu,//完成度
						//发布中传2，保存必填完成 1  未全部完成 0
						releaseStatus:!isFabu ? inputBitianObj.bitian ? '1' : '0': '3'
					},
					ozonProductVariantNews:BiantiArr,
					saveAndSubmit:!isFabu ? 1: 2 // 1.保存  2.保存并发布
				}
				let apiUrl = ''
				if (this.isEdit){
					saveParams.ozonProductNew.id = this.bianjiProductId
					apiUrl = 'ozonProduct/updateOzonProduct'
				} else {
					apiUrl = 'ozonProduct/insertOzonProduct'
				}
				//先删除变体
				if (this.isEdit && ids.length > 0){
					ajaxPost(Baseurl + 'ozonProductVariant/batchRemoveVariant', {
						ids:ids
					}).then(response => {
								if (response.data.code == 200) {
									ajaxPost(Baseurl + apiUrl, saveParams).then(
											(res) => {
												const { code, message, data } = res.data
												if (code == 200) {
													this.$message.success(!isFabu ? '保存成功！':'发布成功！')
													this.dialogVisible = false
													this.saveLoadding = false
													this.get_table_data()
												} else {
													this.$message.error(response.data.message)
												}
											}
									).catch(function(e) {
										this.$message.error(e)
										this.dialogVisible = false
										this.saveLoadding = false
									})
								} else {
									this.$message.error(response.data.message)
									this.dialogVisible = false
									this.saveLoadding = false
								}
							}
					)
				} else {
					ajaxPost(Baseurl + apiUrl, saveParams).then(
							(res) => {
								const { code, message, data } = res.data
								if (code == 200) {
									this.$message.success('保存成功！')
									this.dialogVisible = false
									this.saveLoadding = false
									this.get_table_data()
								} else {
									this.$message.error(message)
									this.dialogVisible = false
									this.saveLoadding = false
								}
							}
					).catch(function(e) {
						this.$message.error(e)
						this.dialogVisible = false
						this.saveLoadding = false
					})
				}
			},
			//返回数字或者null
			returnNumber(val){
				if (val) {
					return parseFloat(val); // 返回数字
				} else {
					return null; // 返回null
				}
			},
			clickEdit(row,type){
            	this.title = type == 'chakan' ? '查看产品':'编辑产品'
            	this.isEdit = true
				this.dialogVisible = true
				this.saveLoadding = true
				this.loading  = this.$loading({
					target: this.$refs.dia_box,
					text: '努力加载中...',
					background: 'rgba(218,218,238,0.2)'
				})
				this.dialogLoding = true
            	const API = Baseurl + 'ozonProduct/getOzonProductDetail/' + row.id
				ajaxGet(API).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						let cangkuParams = {
							sellerId: data.ozonProductNew.sellerId
						}
						this.bizhong = data.ozonProductNew.currencyCode;
						this.getCangku(cangkuParams)
						this.bianjiProductId = data.ozonProductNew.id
						//主要属性
						let ozonProductNew = data.ozonProductNew
						let zhuAttributes = JSON.parse(ozonProductNew.attributes)
						this.resetPage()
						zhuAttributes.forEach(item => {
							//封面视频
							if (item.id == '21845'){
								this.$refs.shipin.fengmianUrl = item.values[0].value
							}
							//产品视频
							if (item.id == '21841'){
								this.$refs.shipin.chanpinUrl = item.values[0].value
							}
							//视频标题
							if (item.id == '21837'){
								this.$refs.shipin.formData.title = item.values[0].value
							}
							//文字描述
							if (item.id == '4191'){
								this.$refs.description.formData.descValue = item.values[0].value
							}
							//尺寸表
							if (item.id == '13164'){
								this.$refs.description.formData.chicunValue = item.values[0].value
							}
							//丰富内容
							if (item.id == '11254'){
								this.$refs.description.formData.jsonValue = item.values[0].value
							}
						})
						let dianpuParams ={
							rid: this.str.rid,
							system: this.str.system,
							companyId: this.str.company_id,
							sellerType: ''
						}
						this.$refs.baseInfo.getdianpuList(dianpuParams)
						this.$refs.baseInfo.formData.sku = ozonProductNew.sku
						this.$refs.baseInfo.allLeimuName = ozonProductNew.typeName + '('+ozonProductNew.typeNameCn +')'
						this.$refs.baseInfo.formData.categoryId = ozonProductNew.categoryId
						this.$refs.baseInfo.formData.typeId = ozonProductNew.typeId
						this.$refs.baseInfo.formData.name = ozonProductNew.name
						this.$refs.uploadPictures.imgListSelect = ozonProductNew.imageList
						this.productImgArr = ozonProductNew.imageList

						this.$refs.wuliu.formData.depth = ozonProductNew.depth
						this.$refs.wuliu.formData.dimensionUnit = ozonProductNew.dimensionUnit
						this.$refs.wuliu.formData.height = ozonProductNew.height
						this.$refs.wuliu.formData.vat = ozonProductNew.vat
						this.$refs.wuliu.formData.weight = ozonProductNew.weight
						this.$refs.wuliu.formData.weightUnit = ozonProductNew.weightUnit
						this.$refs.wuliu.formData.width = ozonProductNew.width
						this.$refs.wuliu.formData.warehouseId = ozonProductNew.warehouseId

						this.selectForm.companyId = ozonProductNew.companyId
						this.selectForm.staffId = ozonProductNew.staffId
						this.$refs.baseInfo.formData.shopId = ozonProductNew.countrySellerId
						this.$refs.baseInfo.formData.sellerId = ozonProductNew.sellerId
						this.$refs.laiyuan.formData.remark = ozonProductNew.remarks
						this.$refs.bianti.ParentSKU = ozonProductNew.sku
						this.$refs.bianti.ParentName = ozonProductNew.name
						this.$refs.bianti.bizhong = this.bizhong
						if (ozonProductNew.sourceLinkList && ozonProductNew.sourceLinkList.length> 0){
							this.$refs.laiyuan.blue_point = ozonProductNew.sourceLinkList.map(item =>{
								return {
									value: item,
									type: true,
								}
							})
						} else {
							this.$refs.laiyuan.blue_point = [{
								value: undefined,
								type: true,
							}]
						}
						if (type == 'chakan'){
							this.isChakan = true
							this.$refs.baseInfo.isChakan = true
							this.$refs.description.isChakan = true
							this.$refs.laiyuan.isChakan = true
							this.$refs.shipin.isChakan = true
							this.$refs.wuliu.isChakan = true
							this.$refs.bianti.isChakan = true
							this.$refs.uploadPictures.isChakan = true
						} else {
							this.isChakan = false
							this.$refs.baseInfo.isChakan = false
							this.$refs.description.isChakan = false
							this.$refs.laiyuan.isChakan = false
							this.$refs.shipin.isChakan = false
							this.$refs.wuliu.isChakan = false
							this.$refs.bianti.isChakan = false
							this.$refs.uploadPictures.isChakan = false
						}
						//变体属性
						let ozonProductVariantNews = data.ozonProductVariantNews
						this.$nextTick(() => {
							this.saveLoadding = false
							let biantizhi = []
							this.$refs.baseInfo.addStatus = 'edit'

							if (ozonProductVariantNews && ozonProductVariantNews.length > 0){
								this.$refs.bianti.tableList = ozonProductVariantNews.map(item =>{
									item.isShowImage = false
									return item
								})
								this.$refs.bianti.oldTableList = JSON.parse(JSON.stringify(ozonProductVariantNews))

								biantizhi = ozonProductVariantNews.map(item =>{
									item.aspectAttributes = JSON.parse(item.aspectAttributes)
									return item
								})
								//所有变体属性
								 let allBianti = biantizhi[0].aspectAttributes
								// ozonProductVariantNews.forEach(item =>{
								// 	item.aspectAttributes.forEach(itemBianti =>{
								// 		//所有变体列表不存在新的循环值，怎push
								// 		if (!allBianti.some(itemAll =>{
								// 			return itemAll.id == itemBianti.id
								// 		})){
								// 			allBianti.push(itemBianti)
								// 		}
								// 	})
								// })
								// {
								// 	complex_id:itemHeader.attributeComplexId,
								// 			id: itemHeader.attributeId, //属性id
								// 		isZhi:isZhi,
								// 		values:values
								// }
								this.$refs.baseInfo.getAttribute(allBianti,'youbianti',zhuAttributes,biantizhi)
							} else {
								this.$refs.baseInfo.getAttribute([],'wubianti',zhuAttributes)
							}

						});
						this.dialogLoding = false
						this.loading.close()
					}
				})

			},
			//展开收起
			clickZhankai(row){
				row.isShowAll = !row.isShowAll
			},
			//返回是否可以发布 true 可以发布
			isFAbu(){
					//必填已经全部填完
					let biTianAll = !this.$refs.baseInfo.formData.formDatasellerId || !this.$refs.baseInfo.allLeimuName
							|| !this.$refs.baseInfo.sku || !this.$refs.baseInfo.topAttributeList
							|| this.$refs.baseInfo.topAttributeList.some(item => {
								return (item.isRequired == 1 && (!item.fieldValue || !item.fieldValue.length))   //必填主属性不存在值
							})
							|| !this.$refs.wuliu.formData.warehouseId && !(this.$refs.wuliu.formData.vat || this.$refs.wuliu.formData.vat == 0)
							|| !this.$refs.wuliu.formData.weight && !this.$refs.wuliu.formData.weightUnit
							|| !this.$refs.wuliu.formData.width && !this.$refs.wuliu.formData.height
							|| !this.$refs.wuliu.formData.depth && !this.$refs.wuliu.formData.dimensionUnit
							|| this.$refs.bianti.returnBitian() && this.$refs.baseInfo.topAttributeList.length == 0
					return !biTianAll

			},
			//保存并发布
			saveAndfabu(){
				let inputBitianObj = this.returnInputLength()
				//全部填完
				if (!inputBitianObj.bitian){
					this.$message('请填写完成必填项后，再行发布！')
				} else {
					this.saveChanpin(true)
				}
            	// if (!this.isFAbu()){
				// 		this.$message('请填写完成必填项后，再行发布！')
				// }
			},
			//修改sku
			changeSku(val){
				this.$refs.bianti.ParentSKU = val
			},
			//修改name
			changeName(val){
				this.$refs.bianti.ParentName = val
				},
			//获取仓库列表
			getCangku(params){
				ajaxPost(Baseurl + 'ozonProduct/getOzonWarehouseList', params).then((res) => {
					const { code, data } = res.data
					if (code == 200) {
						this.$nextTick(() => {
							this.$refs.wuliu.cangkuList = data
						});
					}
				})
			},
			//异常
			clickSKUResult(result){
            	if (result.uploadResult){
					this.dialogResultVisible = true
					this.resultContent = JSON.parse(result.uploadResult)
				}
			},
			returnClass(item){
				//3红4绿
				if(item && item.releaseStatus == '3'){
						return 'item_yuan red_yuan'
				}
				//3红4绿
				if(item && item.releaseStatus == '4'){
						return 'item_yuan green_yuan'
				}
			}
		}
	}
</script>

<style lang="scss">
	@import "./ozon.less";
	.Release {
		width: 98%;
		// background: #F7F7F7;
		padding-bottom: 72px;
		.summary_bag {
			width: 98%;
			margin: auto;
			.summary_complete_bag {
				overflow: hidden;
				.summary_complete {
					overflow: hidden;
					padding: 10px 0;
					border-bottom: 1px #eee solid;
					div {
						padding: 0 10px;
						height: 30px;
						border: #2c8dff 1px solid;
						line-height: 30px;
						text-align: center;
						color: #2c8dff;
						float: left;
						border-radius: 4px;
						cursor: pointer;
					}
					.active {
						background: #2c8dff;
						color: #fff;
					}
				}
			}
			.summary_pagenum {
				width: 100%;
				margin-bottom: 10px;
				overflow: hidden;
				background: #f5f5f5;
				.summary_query {
					width: 20%;
					float: left;
					padding: 0 10px;
					line-height: 32px;
					letter-spacing: 1px;
					color: #585858;
					span {
						color: #2c8dff;
					}
				}
				.block {
					float: right;
				}
			}
			.summary_content {
				width: 100%;
				border: 1px solid #eee;
				overflow: hidden;
				.summary_batch {
					width: 100%;
					overflow: hidden;
					border-bottom: 1px solid #eee;
					span {
						display: block;
						float: left;
						line-height: 20px;
						margin: 10px 0px;
						padding: 0 20px;
						color: #2c8dff;
						overflow: hidden;
						border-left: 1px #2c8dff solid;
					}
					span:nth-child(1) {
						color: #000;
						border-left: 0px;
					}
				}
			}
			.summary_list {
				.scope_img {
					width: 55px;
					height: 55px;
					margin: 0 auto;
					img {
						width: 100%;
						height: 100%;
					}
				}
				.oper {
					color: #2c8dff;
					margin-right: 10px;
					cursor: pointer;
				}
			}
		}
	}
	.item_sku{
		width: 100%;
	}
	.custom-formScreen {
		::v-deep {
			.el-form-item__content {
				width: calc(100% - 125px);
			}
		}
	}
	.zhankai_shouqi{
		width: 30px;
		height: 30px;
		border-radius: 5px;
		background: rgb(168,168,168);
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 15px;
		cursor: pointer;
	}
	.item_yuan{
		width: 15px;
		height: 15px;
		border-radius: 50%;
		margin-left: 5px;
	}
	.red_yuan{
		background: red;
		cursor: pointer;
	}
	.green_yuan{
		background: green;
	}
	.item_err{
		width: 120px;
		text-align: right;
		padding-right: 15px;
	}
	.item_err_content{
		width:calc(100% - 160px);
	}
	.select-row{
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		.label{
			font-size: 16px;
			margin-right: 10px;
		}
		.select-item{
			display: flex;
			align-items: center;
			margin-right: 10px;
			.label{
				margin-right: 5px;
				// flex: 1;
				white-space: nowrap;
			}
			.el-input{
				width: 300px;
			}
		}
		.tip{
			font-size: 16px;
			margin-left: 10px;
		}
	}
	.network-content{
		display: flex;
		flex-wrap: wrap;
		// justify-content: space-between;
		.network-item{
			border: 1px solid #999;
			box-sizing: border-box;
			width: calc((100% - 50px) / 6);
			margin-bottom: 10px;
			padding: 5px;
			position: relative;
			margin-right: 10px;
			&:nth-child(6n){
				margin-right: 0;
			}
			img{
				width: 100%;
				aspect-ratio: 1 / 1;     // 强制图片显示为正方形
				object-fit: cover;       // 图片按比例裁切填满，不变形
				display: block;          // 消除默认行内元素下方空隙
			}
			.title{
				font-size: 16px;
				margin: 5px 0;
				font-weight: bold;
			}
			.score-row{
				display: flex;
				justify-content: space-between;
			}
			&.active{
                border-color: green;
                border: 2px solid green;
                /* 右上角对勾标记 */
                /* 右上角三角形背景的对勾标记 */
                &::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 0;
                    height: 0;
                    border-top: 30px solid green;
                    /* 三角形高度 */
                    border-left: 30px solid transparent;
                    /* 控制三角形宽度 */
                    z-index: 10;
                }
            
                /* 对勾符号 */
                &::before {
                    content: '✓';
                    position: absolute;
                    top: -2px;
                    right: 0;
                    color: white;
                    font-size: 16px;
                    font-weight: bold;
                    z-index: 20;
                }
            }
		}
	}
</style>
